/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { COLORS } from '@/constants';

interface DividerProps {
  vertical?: boolean;
}

const Divider = (props: DividerProps) => {
  const { vertical = false } = props;

  if (vertical) {
    return (
      <div
        style={{
          border: `1px solid ${COLORS.DividerColor}`,
          marginTop: '-1em',
          width: 1,
        }}
      />
    );
  }

  return (
    <div
      style={{
        border: `1px solid ${COLORS.DividerColor}`,
        width: '100%',
        margin: '1em 0',
      }}
    />
  );
};

export default Divider;
